<a routerLink="/home">
  <img alt="Ophardt" height="50" ngSrc="assets/images/webp/ophardt-logo.webp" priority width="190" />
</a>
